import axios from "axios";

const urls = process.env.REACT_APP_BASE_URL;

//공지사항
export const requestNoticeList = (params) =>
  axios
    .post(`${urls}/public/inform/list`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//공지사항 조회수
export const requestNoticeCount = (params) =>
  axios
    .post(`${urls}/public/inform/count`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//faq
export const requestFaqList = (params) =>
  axios
    .post(`${urls}/public/faq/list`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));
